import { PerPage } from "helpers/system-config";
import APIManager from "modules/common/apiManager";
import { CustomDropdown } from "modules/common/components";
import { isAccess } from "modules/common/utils";
import {
  ActionButtons,
  Alert,
  ButtonCommonTheme,
  ControlLabel,
  DataWithLoader,
  DataWrapperClass,
  FormControl,
  Icon,
  ImportFile,
  ModalTrigger,
  ReportPagination,
  SeachForm,
  SettingDropdownMenu,
  Table,
  Tip,
  Wrapper,
  confirm,
} from "modules/theme";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { MenuItem } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { modalType } from "../../../../../helpers/dotenv";
import { globalStateSelector } from "../../../../../store/selector";
import { BackButton, CenterFlexRow } from "../../styles";
import PermissionsAddEdit from "./AddEdit";

export class Permission extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = "Permissions";
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      // permissions: [],
      AccessRoleConfigObject: {},
      accessList: {},
      searchValue: "",
    };
  }

  componentDidMount() {
    this.getBreak(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page, MasterChecked: false });
    this.getBreak(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getBreak(1, perPage, this.state.search);
  }

  search(e) {
    const value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (value.trim() !== "" || value === "") {
        this.setState({ search: value.trim(), searchValue: value });
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.getBreak(1, "", this.state.search);
        }, 500);
      }
    }
  }

  deleteAllData(e) {
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      return data._id;
    });
    this.mAPI.sendPostAPI(
      `access-role/multiple/usingIds`,
      {
        ids: list,
      },
      (data) => {
        this.setState({
          MasterChecked: false,
          SingleChecked: false,
          SelectedList: [],
        });
        this.getBreak(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(
          `${
            data.modifiedCount > 1 ? this.moduleName : "Permission"
          } deleted successfully.`
        );
        this.setState({ currentPage: 1 });
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }
  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }
  deleteBreak(tBreak) {
    var that = this;
    // route, data, sCb, fCb, type, extraHeaders, method
    this.mAPI.sendPostAPI(
      `access-role/${tBreak._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tBreak._id);
        that.setState({
          listData: tD,
          MasterChecked: false,
          SingleChecked: false,
          SelectedList: [],
        });
        that.getBreak(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`Permission deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  getBreak(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `access-role?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });

        if (data) {
          that.setState({
            listData: data.data.map((i) => ({ ...i, selected: false })),
            total: data.data.length,
            MasterChecked: false,
            defaultRole: data.defaultRole,
            SelectedList: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }
  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }
  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getBreak(this.state.currentPage, this.state.perPageCount);
    }
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append('contactListId', this.state.contactId);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    const ImportTrigger = ({ onClick }) => {
      if (isAccess(this.props.access, "add")) {
        return <ButtonCommonTheme type="add" addOnClick={onClick} />;
      } else {
        return <div></div>;
      }
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title="Permissions"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={`my-modal ${this.state.modalType}`}
        >
          <PermissionsAddEdit
            defaultRole={this.state.defaultRole}
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            isEdit={false}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>

        {isAccess(this.props.access, "import") && (
          <ImportFile
            apiUrl={`setting/break/report/import`}
            fetchData={this.importContact}
            importDone={() => {
              _this.setState({ loading: true });
              setTimeout(() => {
                _this.onPerPageChooser(_this.state.perPageCount);
              }, 3000);
            }}
            urlDownload={`permission.csv`}
          ></ImportFile>
        )}
      </span>
    );
  }

  editBreak(tBreak) {
    return (
      <Tip text={`${"Edit"}`} key={`${"Edit"}`}>
        <ButtonCommonTheme
          type="edit"
          editOnClick={() => this.openModal(tBreak)}
        />
      </Tip>
    );
  }

  renderActions(tBreak, index) {
    tBreak["accessList"] = this.state.accessList;
    tBreak["AccessRoleConfigObject"] = this.state.AccessRoleConfigObject;
    return (
      <ActionButtons>
        {this.editBreak(tBreak)}
        {isAccess(this.props.access, "delete") && (
          <CustomDropdown
            index={index}
            totalLength={this.state.listData.length || 0}
          >
            <MenuItem
              style={{ marginLeft: "0px" }}
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteBreak(tBreak, e);
                })
              }
            >
              {"Delete"}
            </MenuItem>
          </CustomDropdown>
        )}
      </ActionButtons>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Permissions"), link: "/settings/Permissions" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              {isAccess(this.props.access, "delete") && (
                <th onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={this.state.MasterChecked}
                    onChange={(e) => this.onMasterCheck(e)}
                  />
                </th>
              )}
              <th>{__("Name")}</th>
              <th>{__("Role")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="Break">
            {this.state.listData &&
              this.state.listData.map((tBreak, index) => (
                <tr key={tBreak._id}>
                  {isAccess(this.props.access, "delete") && (
                    <td onClick={this.onClick}>
                      <FormControl
                        componentClass="checkbox"
                        checked={tBreak.selected}
                        onChange={(e) => this.onItemCheck(e, tBreak)}
                      />
                    </td>
                  )}
                  <td className="">{tBreak.roleName}</td>
                  <td>
                    {tBreak.baseRole && tBreak.baseRole === 6
                      ? "Agent"
                      : tBreak.baseRole === 3
                      ? "Reseller"
                      : tBreak.baseRole === 5
                      ? "Team Lead"
                      : tBreak.baseRole === 2
                      ? "Admin"
                      : "-"}
                  </td>
                  <td>{this.renderActions(tBreak, index)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div>
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>Permissions</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="checkboxDelete"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    )}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Sorry..! No Permissions Found"
                  emptyImage="/images/Break-empty.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}
Permission.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  access: globalStateSelector.getPermission(state, "permission"),
});

export default connect(stateToProps)(Permission);



// WEBPACK FOOTER //
// src/modules/screens/settings/Permissions/components/index.jsx